import React from "react";
import { includes } from "ramda";
import makeStyles from "@mui/styles/makeStyles";
import { useCreatorContext } from "../../CreatorContext";

import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: 0,
  },

  thumbnail: {
    width: 45,
    height: 45,
  },

  main: {
    marginLeft: theme.spacing(3),
    width: 200,
    padding: 0,
    flexGrow: 1,
  },

  title: {
    color: theme.palette.primary.brandPrimary,
    fontSize: "1.6rem",
    lineHeight: "1.7em",
  },

  subtitle: {
    fontSize: "1.2rem",
  },
}));

const AnthologyCard = props => {
  const { anthology } = props;
  const classes = useStyles();
  const context = useCreatorContext();

  return (
    <Container className={classes.root} maxWidth={false}>
      <Avatar
        variant="rounded"
        alt={anthology.name}
        src={
          includes(anthology.id, context.updatedThumbnails)
            ? `${anthology.thumbnailUrl}?tc=${Date.now()}`
            : anthology.thumbnailUrl
        }
        className={classes.thumbnail}
      />

      <div className={classes.main}>
        <Typography classes={{ root: classes.title }} noWrap>
          {anthology.name}
        </Typography>
      </div>
    </Container>
  );
};

export default AnthologyCard;
